/**
 * @name useMenuStates
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Hook personalizado para gerenciar os estados do menu.
 * @package src/components/layouts/UserLayout/components/UserSideBar/hooks/useMenuStates.ts
 **/

import { useState } from 'react';

export const useMenuStates = () => {
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const toggleMenu = (key: string, isParent?: boolean) => {
    // Se o item clicado é um menu pai (de primeiro nível) ou se isParent não foi especificado
    if (isParent === true) {
      if (openKeys.includes(key)) {
        // Se já está aberto, apenas fecha
        setOpenKeys(prev => prev.filter(k => k !== key));
      } else {
        // Se não está aberto, fecha todos os outros menus pai e abre este
        // Filtra os menus pai abertos (que não têm '/' no nome da chave, indicando um submenu)
        const otherParentKeys = openKeys.filter(k => !k.includes('/') && k !== key);
        
        // Remove os menus pai e mantém este, mantendo quaisquer submenus abertos
        setOpenKeys(prev => [
          ...prev.filter(k => k.includes('/') || !otherParentKeys.includes(k)),
          key
        ]);
      }
    } 
    // Se é um submenu (isParent === false ou undefined)
    else {
      if (openKeys.includes(key)) {
        // Se já está aberto, apenas fecha ele, mas mantém o pai aberto
        setOpenKeys(prev => prev.filter(k => k !== key));
      } else {
        // Se não está aberto, adiciona à lista de abertos, mantendo o pai aberto
        setOpenKeys(prev => [...prev, key]);
      }
    }
  };

  const isOpen = (key: string) => openKeys.includes(key);

  return {
    openKeys,
    toggleMenu,
    isOpen
  };
};
